import React, { useMemo, useRef, useState } from "react";
import {
  FlexRowBetween,
  GenericDiv,
  ListHolder,
  PopupDiv,
  TableDayalCard,
} from "../../common/Style";
import { useDispatch, useSelector } from "react-redux";
import undo from "./undo.svg";
import spinner from "../../../assets/common/spinner.svg";
import GenericModal from "../../common/modals/GenericModal";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { checkAuth } from "../../../store/reducers/authReducer";
import { UseInterval } from "../../common/others/UseInterval";
import ChangeCC from "./ChangeCC";
import { getAll } from "../../../store/reducers/guestsReducer";
let multyChoise = {};

const Dayalim = ({ init }) => {
  const dispatch = useDispatch();

  const { user, isTal } = useSelector((state) => state.authReducer);
  const { guests, guestsLoading } = useSelector((state) => state.guestsReducer);
  const [editTables, setEditTables] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [title, setTitle] = useState(user.seatupEventId == "besimple");

  const arr2json = (guests, key) => {
    let arr = [];
    for (const [key, value] of Object.entries(guests)) arr.push(value);
    let obj = {};
    for (let i = 0; i < arr.length; i++)
      if (obj[arr[i][key]] === undefined)
        obj = { ...obj, [arr[i][key]]: { [arr[i]._id]: arr[i] } };
      else
        obj = {
          ...obj,
          [arr[i][key]]: {
            ...obj[arr[i][key]],
            [arr[i]._id]: arr[i],
          },
        };
    return obj;
  };

  let tablesArray = useMemo(() => {
    let tables = [];
    let array = [];
    let count = 0;
    let cc = 0;
    let totalChairs = 0;
    let totalArrived = 0;
    let tableArrived = 0;
    let obj = { ...arr2json(guests, "table") };
    // console.log("obj ", obj);
    if (user.tablesArray.length > 0)
      // אם קיימים שולחנות
      for (let i = 0; i < user.tablesArray.length; i++) {
        totalChairs += user.tablesArray[i].chairs;
        // עבור כל שולחן
        if (obj[i + 1] === undefined) {
          // אם לא קיימים אורחים בשולחן זה - הכנסת כותרת
          array.push(
            <div key={i + 1}>
              <FlexRowBetween style={{ marginTop: "5px" }}>
                <div>{i + 1})</div>
                <div>{user.tablesArray[i].title}</div>
              </FlexRowBetween>
              <FlexRowBetween style={{ marginTop: "5px" }}>
                <div>מכיל {user.tablesArray[i].amount}</div>
                <div style={{ margin: "0 5px" }}>/</div>
                <div>הושבו {0}</div>
              </FlexRowBetween>
              <FlexRowBetween style={{ marginTop: "5px", marginBottom: "5px" }}>
                <div>
                  ערוך{" "}
                  {user.tablesArray[i].chairs || user.tablesArray[i].amount}
                </div>
                <div style={{ margin: "0 5px" }}>/</div>
                <div>הגיעו {0}</div>
              </FlexRowBetween>
            </div>
          );
        } else {
          for (const [key, value] of Object.entries(obj[i + 1])) {
            parseInt(value.arrived) >= 0 &&
              (tableArrived += parseInt(value.arrived));
            count += parseInt(value.accept);
          }
          cc = user.tablesArray[i].chairs || user.tablesArray[i].amount;
          array.push(
            <div key={i + 1}>
              <FlexRowBetween style={{ marginTop: "5px" }}>
                <div>{i + 1})</div>
                <div>{user.tablesArray[i].title}</div>
              </FlexRowBetween>
              <FlexRowBetween style={{ marginTop: "5px" }}>
                <div>מכיל {user.tablesArray[i].amount}</div>
                <div style={{ margin: "0 5px" }}>/</div>
                <div>הושבו {count}</div>
              </FlexRowBetween>
              <FlexRowBetween style={{ marginTop: "5px", marginBottom: "5px" }}>
                <div>
                  ערוך{" "}
                  {user.tablesArray[i].chairs || user.tablesArray[i].amount}
                </div>
                <div style={{ margin: "0 5px" }}>/</div>
                <div
                  style={{
                    padding: "2px 5px",
                    borderRadius: "2px",
                    backgroundColor:
                      tableArrived > cc
                        ? "#f0aeae"
                        : tableArrived == cc ||
                          user.tablesArray[i]?.default == true
                        ? "#d7f0ae"
                        : "#ecac70",
                  }}
                >
                  הגיעו {tableArrived}
                </div>
              </FlexRowBetween>
            </div>
          );
        }

        tables.push(
          <TableDayalCard onClick={() => setEditTables(i)} key={i + 1000}>
            {array}
          </TableDayalCard>
        );
        array = [];
        count = 0;
        tableArrived = 0;
        // }
      }

    return [tables, totalArrived, totalChairs];
  }, [guests, user.tablesArray, title]);

  let guestsArray = useMemo(() => {
    let counter = [0, 0, 0]; // 0 - seat, 1 - stand, 2 - arrive
    const updateCounter = (amount, table, arrive) => {
      if (table) counter[0] += amount;
      else counter[1] += amount;
      if (arrive != null) {
        counter[2] += parseInt(arrive);
      }
    };
    if (Object.keys(guests).length > 0) {
      for (const [key, value] of Object.entries(guests))
        updateCounter(value.accept, value.table, value.arrived);
    }
    return counter[2];
  }, [guests, multyChoise]);

  const hand = () => {
    dispatch(checkAuth());
    dispatch(getAll());
  };

  UseInterval(async () => {
    if (isTal) {
      hand();
    }
  }, 30000);

  return (
    <PopupDiv
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
        overflow: "hidden",
        background: "white",
        fontSize: "14px",
        borderRadius: "0px",
      }}
      onClick={(e) => e.stopPropagation()}
      className="animate__animated animate__fadeIn"
    >
      <div
        style={{
          boxShadow: "0 2px 4px silver",
          width: "100%",
        }}
      >
        <FlexRowBetween
          style={{
            width: "100%",
            margin: "0px",
            alignItems: "flex-start",
          }}
        >
          <GenericDiv
            onClick={() => init(false)}
            style={{
              borderRadius: "0px 0px 0px 7px",
              padding: "5px",
            }}
            background={"#7b96c4"}
          >
            <img src={undo} alt="undo" style={{ width: "23px" }} />
          </GenericDiv>
        </FlexRowBetween>
      </div>

      <FlexRowBetween
        style={{
          maxHeight: `${window.screen.availHeight - 110}px`,
          overflow: "auto",
        }}
      >
        <div
          style={{
            width: "100%",
            margin: "0 auto",
            overflow: "auto",
            height: "100%",
          }}
        >
          <ListHolder style={{ height: "100%" }}>{[tablesArray[0]]}</ListHolder>
        </div>
      </FlexRowBetween>
      {/* {isTal && (
        <FlexRowBetween
          style={{
            width: "min-content",
            border: "2px solid rgba(0, 0, 0, 0.11)",
            borderRadius: "50px",
            padding: "3px",
            position: "absolute",
            cursor: "pointer",
            bottom: "30px",
            left: "20px",
          }}
        >
          <div
            onClick={() => hand()}
            style={{
              padding: "7px 7px",
              backgroundColor: "#5c86ce",
              transition: "all 0.2s",
              borderRadius: "50px",
              color: "white",
              width: "max-content",
              fontSize: "18px",
              position: "relative",
            }}
          >
            {guestsLoading ? (
              <img src={spinner} width="50" alt="spinner" />
            ) : (
              parseInt(guestsArray) - 1
            )}
          </div>
        </FlexRowBetween>
      )} */}
      {isTal && (
        <div
          style={{
            background: "rgba(0, 0, 0, 0.8)",
            color: "white",
            padding: "4px 6px",
            borderRadius: "6px",
            fontSize: "14px",
            textAlign: "center",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            width: "min-content",
            position: "absolute",
            bottom: "30px",
            left: "80px",
          }}
        >
          <div style={{ fontSize: "12px", marginBottom: "2px" }}>עריכות</div>
          <div style={{ fontSize: "16px" }}>{tablesArray[2]}</div>
        </div>
      )}

      {isTal && (
        <div
          onClick={() => hand()}
          style={{
            background: "#5c86ce",
            color: "white",
            padding: "4px 6px",
            borderRadius: "6px",
            fontSize: "14px",
            textAlign: "center",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            width: "min-content",
            position: "absolute",
            bottom: "30px",
            left: "20px",
          }}
        >
          <div style={{ fontSize: "12px", marginBottom: "2px" }}>
            {guestsLoading ? (
              <img src={spinner} width="50" alt="spinner" />
            ) : (
              parseInt(guestsArray)
            )}
          </div>
          <div style={{ fontSize: "16px" }}>הגיעו</div>
        </div>
      )}

      {showLoading && <OpacityLoading />}

      {(editTables || parseInt(editTables) == 0) && (
        <GenericModal
          init={setEditTables}
          div={<ChangeCC init={setEditTables} ind={editTables} />}
        />
      )}
    </PopupDiv>
  );
};

export default Dayalim;
